export const HOME = "/";

export const CONTACT = "/contact";
export const ABOUT = "/about";

export const SIGNUP = "/auth/register";
export const LOGIN = "/auth/login";

export const ABOUT_ME = "/profile/about_me";

// setting tabs routes
export const PROFILE = "/auth/users/:id";
export const UPDATE_PROFILE = "/auth/updateProfile";
export const CONFIRM_ACCOUNT = "/confirmAccount";
export const FORGOT_PASSWORD = "/forgotPassword";

export const DASHBOARD = "/dashboard";
export const SCHOOL = "/schools_tescomit";
export const USER = "/users_tescomit";
export const PRINCIPALSANDVICEPRINCIPALS = "/principalsAndViceprincipals";
export const STAFFPOSTING = "/staffPosting"
export const POSTINGREPORTS = "/postingReports"
export const UPDATESCHOOL = "/updateSchools"
export const MAGAZINE = "magazine"

export const BATCHPRINCIPALSANDVICEPRINCIPALS = "/batchPrincipalsAndVicePrincipals"
